export default __webpack_public_path__ + "static/media/Instantstart.a296794c.svg";